import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { getCurrencySymbolSettings } from '../../common/formatHelper';
import { getDefaultMeasure, getMeasureTitle } from '../../common/measureHelper';
import ButtonSwitchMulti from '../../components/actions/ButtonSwitchMulti';
import { Stat } from '../../components/stats/Stat';
import { StatGroup } from '../../components/stats/StatGroup';
import { warehouseSelected } from '../../store/warehouse.state';
import ActualityAggregatedStatsMetricPieChart from '../charts/ActualityAggregatedStatsMetricPieChart';
import ActualityAggregatedStats from '../components/ActualityAggregatedStats';
import FeedEventProcessTypeSummary from '../components/FeedEventProcessTypeSummary';
import { useActualityStatsCategories } from '../constants/actuality.categories';
import { actualityProcessStats } from '../store/actuality.kpi.state';

const FeedEventsStats: React.FC = () => {
  const { t } = useTranslation('feed');
  const { t: tMeasures } = useTranslation('measures');

  const stats = useRecoilValue(actualityProcessStats);

  const wh = useRecoilValue(warehouseSelected);
  const systemCurrency = getCurrencySymbolSettings(wh.currency).symbol;
  const sizeMeasureValue = getMeasureTitle(
    getDefaultMeasure(wh.measurementSystem, 'distance'),
    tMeasures,
  );

  const [selectedCategoryKey, setSelectedCategoryKey] = useState('duration');

  // Use the shared categories hook
  const categories = useActualityStatsCategories(
    systemCurrency,
    sizeMeasureValue,
  );
  const categoriesMap = _.keyBy(categories, 'key');
  const category = categoriesMap[selectedCategoryKey];

  return (
    <>
      {/* New Summary Component */}
      <FeedEventProcessTypeSummary className="mb-4" />

      {/* Existing Individual Process Type Breakdowns */}
      {_.map(stats, (row, index) => (
        <StatGroup
          key={`process-stats-${row['processType'] || 'unknown'}-${index}`}
          title={row['eventProcessType'] || t`Unknown`}
          subTitle={t`Stats`}
          helpNavTo={`actuality/actuality-kpi`}
          className="!text-xs"
        >
          <Stat className="gap-2">
            <ActualityAggregatedStats
              data={row}
              mode="summary"
              // summaryFields now has good defaults, but we can override if needed
              summaryFields={[
                'analyzedDuration',
                'analyzedDistance',
                'netUomsPerformance',
                'durationDiff',
              ]}
              // showAll={false}
              // hasCategoryStats={false}
            />
          </Stat>

          <ActualityAggregatedStatsMetricPieChart
            key={`process-stats-${row['processType'] || 'unknown'}-${index}`}
            title={category.title}
            row={row}
            metrics={category.metrics}
            metricGroups={category.metricGroups}
            showAsPercentage={selectedCategoryKey === 'share'}
            switchUnitOfMeasure={
              <ButtonSwitchMulti
                autoSize
                className="mx-3"
                classNameLabel="text-xxs py-1 px-2 truncate"
                buttonType="minimal"
                options={categories.map(c => ({
                  id: c.key,
                  label: c.title,
                  icon: c.icon,
                }))}
                selectedIndex={categories.findIndex(
                  c => c.key === selectedCategoryKey,
                )}
                onClick={index => setSelectedCategoryKey(categories[index].key)}
              />
            }
          />
        </StatGroup>
      ))}
    </>
  );
};

export default FeedEventsStats;
